module.exports = __webpack_public_path__ + "img/12_dice[12].5042f28c.png";